import styled from "styled-components";
import PageTopTitle from "../../components/shared/PageTopTitle";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  IMMDegeriOptions,
  aracTuruOptions,
} from "../../utils/sigortaTeklifOptions";
import Button from "../../components/shared/button/Btn";
import {
  addSigortaTeklif,
  getSigortaBanner,
} from "../../features/sigorta/sigortaSlice";
import SmallSpinner from "../../components/shared/spinners/SmallSpinner";

// import sigortaImg from "../../images/img/sigorta.png"
import InputText from "../../components/shared/input/new/InputText";
import InputDate from "../../components/shared/input/new/InputDate";
import InputSelect from "../../components/shared/input/new/InputSelect";
import InputPhoneFormat from "../../components/shared/input/new/InputPhoneFormat";
import useWindowDimensions from "../../hooks/useWindowSize";

const ZORUNLU_TRAFIK_SIGORTASI = "Zorunlu Trafik Sigortası";

const sigortaTuruOptions = [
  {
    value: "Zorunlu Trafik Sigortası",
    text: "Zorunlu Trafik Sigortası",
  },
  {
    value: "Kasko",
    text: "Kasko",
  },
  {
    value: "Yük Sigortası",
    text: "Yük Sigortası",
  },
];

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .content {
      width: calc(100% - 200px);
      margin: 60px 100px;
      display: flex;
      flex-direction: column;
      height: auto;
      margin-bottom: 80px;
      gap: 40px;

      .side-container {
        width: 100%;
        display: flex;
        justify-content: space-around;
        height: auto;
        gap: 40px;
        @media (max-width: 1200px) {
          flex-direction: column;
        }

        .side {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;

          .desc {
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            color: ${({ theme }) => theme.mainTextColor};
          }

          .err-message {
            font-size: 14px;
            font-weight: 600;
            color: var(--color-main);
          }

          .sigorta-banner-img {
            width: 100%;
            border-radius: 10px;
            border: 1px solid #004d95;
          }

          .btn-container {
            margin-top: 40px;
          }
        }

        .side-1 {
          @media (max-width: 1200px) {
            width: 100%;
          }

          .question-input-container {
            position: relative;

            .arrow {
              position: absolute;
              width: 20px;
              height: 20px;
              border-radius: 5px;
              background-color: ${({ theme }) => theme.secondaryBgColor};
              border: 0.5px solid ${({ theme }) => theme.mainBorderColor};
              top: 40px;
              left: 45%;
              -moz-transform: scale(1) rotate(50deg);
              -webkit-transform: scale(1) rotate(50deg);
              -o-transform: scale(1) rotate(50deg);
              -ms-transform: scale(1) rotate(50deg);
              transform: scale(1) rotate(50deg);
            }

            .imm-desc-container {
              position: absolute;
              top: 50px;
              padding: 20px;
              background-color: ${({ theme }) => theme.secondaryBgColor};
              width: 100%;
              border-radius: 20px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 20px;
              color: ${({ theme }) => theme.mainTextColor};
              border: 0.5px solid ${({ theme }) => theme.mainBorderColor};

              h4 {
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
              }

              p {
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
              }
            }
          }
        }

        .side-2 {
          width: calc(40% - 20px);
          @media (max-width: 1200px) {
            width: 100%;
          }
        }
      }
    }
  }
`;

const SigortaTeklifi = () => {
  const { isLoadingAddSigortaTeklif, isAddSigortaResSuccess, sigortaBanner } =
    useSelector((state) => state.sigorta);

  const dispatch = useDispatch();
  const { windowDimensions } = useWindowDimensions();

  const [phoneValue, setPhoneValue] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [sigortaData, setSigortaData] = useState({
    phoneNumber: "",
    plaka: "",
    modelYear: "",
    ruhsatSahibiTcNo: "",
    sigortaBitisTarihi: "",
    aracinKaskoDegeri: "",
  });

  const [sigortaType, setSigortaType] = useState({
    value: "",
    text: "",
  });

  const [aracType, setAracType] = useState({
    value: "",
    text: "",
  });

  const [immDegeri, setImmDegeri] = useState({
    value: "",
    text: "",
  });

  const isZorunluTrafikSigortasi =
    sigortaType.value === ZORUNLU_TRAFIK_SIGORTASI;

  const hasRequiredFields = Boolean(
    phoneValue &&
      phoneValue !== "90" &&
      sigortaType.value &&
      aracType.value &&
      sigortaData.plaka &&
      sigortaData.ruhsatSahibiTcNo &&
      sigortaData.modelYear &&
      (isZorunluTrafikSigortasi || immDegeri.value)
  );

  const handleChange = ({ type, e }) => {
    const { name, value } = e?.target || {};

    if (!name) return;

    if (type === "number") {
      setSigortaData((prev) => ({
        ...prev,
        [name]: value.replace(/[^0-9]/g, ""),
      }));
      return;
    }

    if (type === "plate") {
      setSigortaData((prev) => ({
        ...prev,
        [name]: value
          .toLocaleUpperCase("tr-TR")
          .replace(/\s+/g, "")
          .replace(/[^0-9A-ZÇĞİÖŞÜ]/g, ""),
      }));
      return;
    }

    if (type === "date") {
      const today = new Date().toISOString().split("T")[0];

      if (value && value < today) {
        return;
      }

      setSigortaData((prev) => ({
        ...prev,
        [name]: value,
      }));
      return;
    }

    setSigortaData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSigortaTypeChange = (selectedOption) => {
    const isTrafikSigortasi =
      selectedOption?.value === ZORUNLU_TRAFIK_SIGORTASI;

    setSigortaType(selectedOption);

    setSigortaData((prev) => ({
      ...prev,
      aracinKaskoDegeri: isTrafikSigortasi
        ? null
        : prev.aracinKaskoDegeri ?? "",
    }));

    setImmDegeri((prev) => {
      if (isTrafikSigortasi) {
        return {
          value: null,
          text: "",
        };
      }

      if (prev?.value === null) {
        return {
          value: "",
          text: "",
        };
      }

      return prev;
    });
  };

  useEffect(() => {
    if (isAddSigortaResSuccess) {
      setSigortaData({
        phoneNumber: "",
        plaka: "",
        modelYear: "",
        ruhsatSahibiTcNo: "",
        sigortaBitisTarihi: "",
        aracinKaskoDegeri: "",
      });

      setPhoneValue("");

      setSigortaType({
        value: "",
        text: "",
      });

      setAracType({
        value: "",
        text: "",
      });

      setImmDegeri({
        value: "",
        text: "",
      });

      setIsSubmitted(false);
      setErrorMessage(false);
    }
  }, [isAddSigortaResSuccess]);

  useEffect(() => {
    if (!isSubmitted) return;

    setErrorMessage(!hasRequiredFields);
  }, [isSubmitted, hasRequiredFields]);

  const handleSubmit = () => {
    setIsSubmitted(true);

    if (hasRequiredFields) {
      const data = {
        phoneNumber: phoneValue?.slice(2),
        sigortaTuru: sigortaType.value,
        aracTuru: aracType.value,
        plaka: sigortaData.plaka,
        ruhsatSahibiTcNo: sigortaData.ruhsatSahibiTcNo,
        aracınKaskoDegeri: isZorunluTrafikSigortasi
          ? null
          : parseInt(sigortaData.aracinKaskoDegeri) || 0,
        immDegeri: isZorunluTrafikSigortasi ? null : immDegeri.value,
        aracYili: sigortaData.modelYear,
        carYear: sigortaData.modelYear,
        ruhsatSeriNo: sigortaData.ruhsatSahibiTcNo,
        durum: "aranmadı",
        adSoyad: "",
      };

      dispatch(addSigortaTeklif(data));
    } else {
      setErrorMessage(true);
    }
  };

  useEffect(() => {
    dispatch(getSigortaBanner());
  }, [dispatch]);

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Sigorta Teklifi"} position="sticky" />

        <div className="content">
          <div className="side-container">
            <div className="side side-1">
              <div className="desc">
                Bu menü sayesinde size özel en uygun sigorta teklifleri
                alabilirsiniz.
              </div>

              <InputPhoneFormat
                data={phoneValue}
                setData={setPhoneValue}
                name={"phoneNumber"}
                labelText="Cep Telefonu"
                inputWidth={windowDimensions?.width < 450 ? "350px" : "400px"}
              />

              <InputSelect
                data={sigortaType.text}
                setData={handleSigortaTypeChange}
                name={"sigortaType"}
                initialOptions={sigortaTuruOptions}
                labelText={"Sigorta Türü"}
                inputWidth={windowDimensions?.width < 450 ? "350px" : "400px"}
              />

              <InputText
                data={sigortaData.plaka}
                setData={(e) => handleChange({ type: "plate", e })}
                name={"plaka"}
                labelText="Araç Plakası"
                inputWidth={windowDimensions?.width < 450 ? "350px" : "400px"}
                max={10}
              />

              <InputSelect
                data={aracType.text}
                setData={setAracType}
                initialOptions={aracTuruOptions}
                name={"aracType"}
                labelText={"Araç Türü"}
                inputWidth={windowDimensions?.width < 450 ? "350px" : "400px"}
              />

              <InputText
                data={sigortaData.modelYear}
                setData={(e) => handleChange({ type: "number", e })}
                name={"modelYear"}
                labelText="Model Yılı"
                inputWidth={windowDimensions?.width < 450 ? "350px" : "400px"}
                max={4}
              />

              <InputText
                data={sigortaData.ruhsatSahibiTcNo}
                setData={(e) => handleChange({ type: "number", e })}
                name={"ruhsatSahibiTcNo"}
                labelText="Ruhsat Sahibi TC No"
                inputWidth={windowDimensions?.width < 450 ? "350px" : "400px"}
                max={11}
              />

              <InputDate
                data={sigortaData.sigortaBitisTarihi}
                min={new Date().toISOString().split("T")[0]}
                setData={(e) => handleChange({ type: "date", e })}
                name={"sigortaBitisTarihi"}
                labelText="Sigorta Bitiş Tarihi"
                inputWidth={windowDimensions?.width < 450 ? "350px" : "400px"}
              />

              {!isZorunluTrafikSigortasi && (
                <>
                  <InputText
                    data={sigortaData.aracinKaskoDegeri ?? ""}
                    setData={(e) => handleChange({ type: "number", e })}
                    name={"aracinKaskoDegeri"}
                    labelText="Kasko için Aracın Kasko Değeri"
                    inputWidth={
                      windowDimensions?.width < 450 ? "350px" : "400px"
                    }
                  />

                  <InputSelect
                    data={immDegeri.text}
                    setData={setImmDegeri}
                    initialOptions={IMMDegeriOptions}
                    name={"immDegeri"}
                    labelText={"Kasko için İstenen İMM Değeri"}
                    inputWidth={
                      windowDimensions?.width < 450 ? "350px" : "400px"
                    }
                  />
                </>
              )}

              {errorMessage && isSubmitted && (
                <div className="err-message">
                  Lütfen tüm alanları doldurun ve tekrar deneyin.
                </div>
              )}

              <div className="btn-container">
                <Button
                  type="button"
                  background={"#fff"}
                  color={"#E85446"}
                  handleClick={handleSubmit}
                  padding="0 10px"
                  width="260px"
                >
                  {isLoadingAddSigortaTeklif ? (
                    <SmallSpinner
                      size={"20px"}
                      color={"#fff"}
                      bgColor={"#E85446"}
                    />
                  ) : (
                    "Sigorta Teklifi Al"
                  )}
                </Button>
              </div>
            </div>

            <div className="side side-2">
              {sigortaBanner && (
                <img
                  className="sigorta-banner-img"
                  src={`${process.env.REACT_APP_API_IMG_URI}${sigortaBanner}`}
                  alt="sigorta-banner"
                  title=""
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default SigortaTeklifi;